import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'

import Icon from 'Pods/Shared/Icon/Icon'

class ImagesDropzone extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isDisabled: props.isDisabled,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isDisabled !== this.props.isDisabled) {
      this.setState({ isDisabled: this.props.isDisabled })
    }
  }

  render() {
    return (
      <div className="dropzone-container--grey">
        <Dropzone
          className="drop-area"
          activeClassName="is-active"
          accept=".png,.jpg,.jpeg, image/png,image/jpeg,image/jpg"
          disablePreview
          disabled={this.state.isDisabled}
          onDrop={this.props.onDrop}
        >
          <div className="drop-area__text">
            Drag & Drop images here or
            <span className="btn btn-fat btn-primary u-ml10">Browse</span>
          </div>
          <Icon type={['fal', 'image']} notSpaced />
        </Dropzone>
      </div>
    )
  }
}

ImagesDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
}

export default ImagesDropzone
